import {useDispatch} from 'react-redux';
import Alert from '../../../common/component/Alert';
import Text from '../../../common/component/Text';
import {NOTICE_POPUP_KEY} from '../../../common/constant';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {ButtonSet} from '../../../common/type/alert';
import {setLocalStorageString} from '../../../common/util/storage';
import useDelayClosePopup from '../../../commonSub/hook/useDelayClosePopup';
import {actions} from '../state/action';
import {IMessageProps} from '../type';

export default function NoticePopup({onFinish}: IMessageProps) {
  const dispatch = useDispatch();
  const noticePopup = useTypedSelector(state => state.home.noticePopup);

  useDelayClosePopup({isShowPopup: !!noticePopup, onFinish});

  const closePopup = () => {
    dispatch(actions.setValue('noticePopup', undefined));
  };

  return (
    <Alert
      isOpen={!!noticePopup}
      callback={() => {
        noticePopup?.id &&
          setLocalStorageString({
            key: NOTICE_POPUP_KEY,
            value: noticePopup?.id,
          });
        closePopup();
      }}
      buttonSet={ButtonSet.Confirm}
      onRequestClose={closePopup}
      labelConfirm={noticePopup?.buttonTitle}
      title={noticePopup?.title}
      isTextAlignCenter={false}
      desc={
        noticePopup && (
          <>
            <Text className="mt-9 s14-medium-white light:text-black">
              {noticePopup.date}
            </Text>
            <Text className="mt-10 leading-18 s13-regular-grey08">
              {noticePopup.content}
            </Text>
          </>
        )
      }
    />
  );
}
